import logger from '../utils/logger';
// Функция для уведомления об изменении авторизации
export const triggerAuthChange = () => {
  // Создаем кастомное событие для уведомления об изменениях в localStorage
  window.dispatchEvent(new Event('authChange'));
};

// Обертка для localStorage.removeItem с уведомлением
export const removeAuthToken = () => {
  logger.log('Удаление токена авторизации');
  localStorage.removeItem('Authorization');
  triggerAuthChange();
};

// Обертка для localStorage.setItem с уведомлением
export const setAuthToken = (token) => {
  logger.log('Сохранение токена авторизации:', token);
  localStorage.setItem('Authorization', token);
  triggerAuthChange();
};

// Получение токена
export const getAuthToken = () => {
  return localStorage.getItem('Authorization');
};

// Проверка наличия токена
export const hasAuthToken = () => {
  const token = localStorage.getItem('Authorization');
  return token !== null && token !== undefined && token !== '';
};